import { httpPost } from '../modules/api';
import notify from './notify';

export const WORDPRESS_SINGLE_ID = 1;
export const WORDPRESS_MULTI_ID = 2;
export const PRO_PLAN_ID = 3;
export const TEAM_PLAN_ID = 4;

export const checkout = async (itemId) => {
    try {
        const { sessionId } = await httpPost('/payments/checkout-sessions', { itemId });
        var stripe = window.Stripe(process.env.REACT_APP_STRIPE_API_KEY);
        await stripe.redirectToCheckout({ sessionId });
    } catch (e) {
        console.error(e);
        notify.error('Something went wrong during checkout. Please contact support.');
    }
};
